import { render, staticRenderFns } from "./SpaceDetailsDialog.vue?vue&type=template&id=6e090bfe&scoped=true"
import script from "./SpaceDetailsDialog.vue?vue&type=script&lang=js"
export * from "./SpaceDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e090bfe",
  null
  
)

export default component.exports